import { find, get } from 'lodash';
import { mapActions, mapState } from 'pinia';
import { auth } from 'src/store/auth';
import { tags } from 'src/store/tags';

export default {
  computed: {
    ...mapState(auth, ['userDetails']),
    ...mapState(tags, ['availableTagsFormatted']),
  },

  methods: {
    ...mapActions(tags, ['reloadTags']),

    getTagStyle(tag) {
      const tagObj = find(this.availableTagsFormatted, { value: tag });
      if (!tagObj) {
        return '';
      }

      return `color:${get(tagObj, 'textColor', '')};background-color:${get(tagObj, 'color', '')}`;
    }, // getTagStyle()

    getTagTextColor(tag) {
      const tagObj = find(this.availableTagsFormatted, { value: tag });
      if (!tagObj) {
        return null;
      }
      return tagObj.textColor;
    },

  },
};
